import React, { useEffect, useState } from "react";
import {
  Table,
  Form,
  Offcanvas,
  Pagination,
} from "react-bootstrap";
import {
  FiPlus,
  FiSearch,
  FiTrash2,
  FiHome,
  FiChevronRight,
} from "react-icons/fi";
import Select from "react-select";
import { getStaff } from "../../store/slices/staff";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";

import {
  getSubjectTeacher,
  deletesubjectTeacher,
} from "../../store/slices/subjectteacher";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function SubjectTeacher() {
  const dispatch = useDispatch();

  const [showFilter, setShowFilter] = useState(false);

  const {
    subjectTeacher = [],
    loading,
    error,
    totalDataCount = 0,
  } = useSelector(
    (state) => state.subjectTeacher || {}
  );

  const [teacherList, setTeacherList] = useState([]);

  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");

  const fetchSubjectTeachers = (
    page = currentPage,
    teacherId = search
  ) => {
    dispatch(
      getSubjectTeacher({
        page,
        limit: itemsPerPage,
        teacherId,
      })
    );
  };

  /* ---------- FETCH SUBJECT TEACHERS ---------- */

  useEffect(() => {
    fetchSubjectTeachers(currentPage, search);
  }, [currentPage]);

  /* ---------- FETCH TEACHERS ---------- */

  useEffect(() => {
    dispatch(
      getStaff({
        role: "teacher",
        limit: 1000,
      })
    )
      .unwrap()
      .then((res) => {
        setTeacherList(res?.data || []);
      })
      .catch(() =>
        toast.error("Failed to fetch teachers")
      );
  }, [dispatch]);

  const teacherOptions = teacherList.map((teacher) => ({
    value: teacher._id,
    label: teacher.name,
  }));

  /* ---------- DELETE ---------- */

  const handleDelete = (id) => {
    if (!id) return;


    const confirmDelete = window.confirm(
      "Are you sure you want to delete this subject teacher?"
    );

    if (!confirmDelete) return;

    dispatch(deletesubjectTeacher(id))
      .unwrap()
      .then(() => {
        toast.success("Deleted successfully");

        fetchSubjectTeachers(
          currentPage,
          search
        );
      })
      .catch((err) => {
        toast.error(err || "Delete failed");
      });


  };

  /* ---------- FILTER ---------- */

  const handleFilter = () => {
    setCurrentPage(1);


    fetchSubjectTeachers(1, search);

    setShowFilter(false);


  };

  const handleClear = () => {
    setSearch("");


    setCurrentPage(1);

    fetchSubjectTeachers(1, "");

    setShowFilter(false);


  };

  const totalPages = Math.ceil(
    totalDataCount / itemsPerPage
  );

  const paginatedData = subjectTeacher;

  if (error) {
    return (<p className="p-4 text-danger">
      {error} </p>
    );
  }

  return (
    <>
      {/* ================= HEADER ================= */}


      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">

            <div className="home-icon">
              <Link to="/institute/home">
                <FiHome
                  style={{
                    color: "white",
                    marginTop: "-4px",
                  }}
                />
              </Link>
            </div>

            <FiChevronRight className="separator" />

            <span className="active">
              Subject Teacher
            </span>

          </div>

          <div className="d-flex gap-2">

            <button
              className="btn-cancel d-flex align-items-center gap-2"
              onClick={() => setShowFilter(true)}
            >
              <FiSearch />
              Filter
            </button>

            <Link
              to="/institute/add-subject-teacher"
              className="add-btn"
            >
              <FiPlus />
              Add Subject Teacher
            </Link>

          </div>

        </div>
      </div>


      {/* ================= TABLE ================= */}

      <div className="staff-card">

        <div className="table-responsive">

          <Table className="staff-table align-middle">

            <thead>
              <tr>
                <th className="text-center">#</th>

                <th className="text-center">
                  Teacher
                </th>

                <th className="text-center">
                  Subject
                </th>

                <th className="text-center">
                  Standard
                </th>

                <th className="text-center">
                  Section
                </th>

                <th className="text-center">
                  Action
                </th>
              </tr>
            </thead>


            <tbody>

              {/* ================= SKELETON ================= */}

              {loading ? (

                Array.from({ length: 8 }).map(
                  (_, index) => (

                    <tr key={index}>

                      <td className="text-center">
                        <Skeleton width={30} />
                      </td>

                      <td className="text-center">
                        <Skeleton width={130} />
                      </td>

                      <td className="text-center">
                        <Skeleton width={120} />
                      </td>

                      <td className="text-center">
                        <Skeleton width={100} />
                      </td>

                      <td className="text-center">
                        <Skeleton width={100} />
                      </td>

                      <td className="text-center">
                        <Skeleton
                          width={35}
                          height={30}
                          borderRadius={5}
                        />
                      </td>

                    </tr>
                  )
                )

              ) : paginatedData.length === 0 ? (

                <tr>
                  <td
                    colSpan="6"
                    className="text-center"
                  >
                    No subject teachers found
                  </td>
                </tr>

              ) : (

                paginatedData.map(
                  (item, index) => (

                    <tr
                      key={item._id || index}
                    >

                      <td className="text-center">
                        {(currentPage - 1) *
                          itemsPerPage +
                          index +
                          1}
                      </td>

                      <td className="text-center">
                        {item.teacherId?.name || "-"}
                      </td>

                      <td className="text-center">
                        {item.subjectId?.name || "-"}
                      </td>

                      <td className="text-center">
                        {item.standardId?.name || "-"}
                      </td>

                      <td className="text-center">
                        {item.sectionId?.name || "-"}
                      </td>

                      <td className="text-center">

                        <button
                          className="edit-btn"
                          onClick={() =>
                            handleDelete(item._id)
                          }
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <FiTrash2 size={16} />
                        </button>

                      </td>

                    </tr>
                  )
                )

              )}

            </tbody>

          </Table>

        </div>


        {/* ================= PAGINATION ================= */}

        {!loading && totalPages > 0 && (

          <div className="d-flex justify-content-end my-3">

            <Pagination className="mb-0">

              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() =>
                  setCurrentPage((p) => p - 1)
                }
              />

              {Array.from(
                { length: totalPages },
                (_, index) => {

                  const page = index + 1;

                  if (
                    page === 1 ||
                    page === totalPages ||
                    (
                      page >= currentPage - 1 &&
                      page <= currentPage + 1
                    )
                  ) {
                    return (
                      <Pagination.Item
                        key={page}
                        active={
                          page === currentPage
                        }
                        onClick={() =>
                          setCurrentPage(page)
                        }
                      >
                        {page}
                      </Pagination.Item>
                    );
                  }

                  if (
                    page === currentPage - 2
                  ) {
                    return (
                      <Pagination.Ellipsis
                        key={`left-${page}`}
                        disabled
                      />
                    );
                  }

                  if (
                    page === currentPage + 2
                  ) {
                    return (
                      <Pagination.Ellipsis
                        key={`right-${page}`}
                        disabled
                      />
                    );
                  }

                  return null;
                }
              )}

              <Pagination.Next
                disabled={
                  currentPage === totalPages ||
                  totalPages === 0
                }
                onClick={() =>
                  setCurrentPage((p) => p + 1)
                }
              />

            </Pagination>

          </div>

        )}

      </div>


      {/* ================= FILTER ================= */}

      <Offcanvas
        show={showFilter}
        onHide={() => setShowFilter(false)}
        placement="end"
      >

        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            Filter Subject Teacher
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>

          <Select
            className="mb-3"
            options={teacherOptions}
            value={
              teacherOptions.find(
                (t) => t.value === search
              ) || null
            }
            onChange={(selected) =>
              setSearch(
                selected?.value || ""
              )
            }
            placeholder="Select Teacher"
            isClearable
            isSearchable
          />

          <div className="d-flex gap-2">

            <button
              className="btn-cancel w-100"
              onClick={handleClear}
            >
              Clear
            </button>

            <button
              className="btn-submit w-100"
              onClick={handleFilter}
            >
              Apply
            </button>

          </div>

        </Offcanvas.Body>

      </Offcanvas>
    </>


  );
}
